<template>
  <form-section
    :title="$t('Integrations_Shopify_Webhooks_Form_Title')"
    :description="$t('Integrations_Shopify_Webhooks_Form_Description')"
  >
    <el-form-item
      v-for="(eventHook, index) in events"
      :key="index"
      :label="$t(eventHook.label)"
    >
      <p class="webhook-desc">
        {{ $t(eventHook.description) }}
      </p>
      <el-checkbox
        v-for="event in eventHook.values"
        :key="event.name"
        :label="$t(event.label)"
        v-model="event.value"
        @change="onCheckboxChange(event)"
      />
    </el-form-item>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import { customConfirm } from '@/core/helpers'

export default {
  name: 'EventsStep',

  components: { FormSection },

  props: {
    model: {
      type: Object
    }
  },

  data() {
    return {
      webhookCheckoutEvents: [
        {
          name: 'checkouts/create',
          label: 'Integrations_Shopify_Webhooks_Label_Create',
          value: false
        },
        {
          name: 'checkouts/update',
          label: 'Integrations_Shopify_Webhooks_Label_Update',
          value: false
        },
        {
          name: 'checkouts/delete',
          label: 'Integrations_Shopify_Webhooks_Label_Delete',
          value: false
        }
      ],
      webhookCustomersEvents: [
        {
          name: 'customers/create',
          label: 'Integrations_Shopify_Webhooks_Label_Create',
          value: false
        },
        {
          name: 'customers/disable',
          label: 'Integrations_Shopify_Webhooks_Label_Disable',
          value: false
        },
        {
          name: 'customers/enable',
          label: 'Integrations_Shopify_Webhooks_Label_Enable',
          value: false
        },
        {
          name: 'customers/update',
          label: 'Integrations_Shopify_Webhooks_Label_Update',
          value: false
        },
        {
          name: 'customers/delete',
          label: 'Integrations_Shopify_Webhooks_Label_Delete',
          value: false
        }
      ],
      webhookDraftOrdersEvents: [
        {
          name: 'draft_orders/create',
          label: 'Integrations_Shopify_Webhooks_Label_Create',
          value: false
        },
        {
          name: 'draft_orders/update',
          label: 'Integrations_Shopify_Webhooks_Label_Update',
          value: false
        },
        {
          name: 'draft_orders/delete',
          label: 'Integrations_Shopify_Webhooks_Label_Delete',
          value: false
        }
      ],
      webhookOrdersEvents: [
        {
          name: 'orders/cancelled',
          label: 'Integrations_Shopify_Webhooks_Label_Cancelled',
          value: false
        },
        {
          name: 'orders/create',
          label: 'Integrations_Shopify_Webhooks_Label_Create',
          value: false,
          defaultValue: true
        },
        {
          name: 'orders/fulfilled',
          label: 'Integrations_Shopify_Webhooks_Label_Fulfilled',
          value: false
        },
        {
          name: 'orders/paid',
          label: 'Integrations_Shopify_Webhooks_Label_Paid',
          value: false
        },
        {
          name: 'orders/partially_fulfilled',
          label: 'Integrations_Shopify_Webhooks_Label_PartiallyFulfilled',
          value: false
        },
        {
          name: 'orders/updated',
          label: 'Integrations_Shopify_Webhooks_Label_Update',
          value: false
        },
        {
          name: 'orders/delete',
          label: 'Integrations_Shopify_Webhooks_Label_Delete',
          value: false
        },
        {
          name: 'orders/edited',
          label: 'Integrations_Shopify_Webhooks_Label_Edited',
          value: false
        }
      ],
      webhookCheckoutOrderTransactions: [
        {
          name: 'order_transactions/create',
          label: 'Integrations_Shopify_Webhooks_Label_Create',
          value: false
        }
      ],
      webhookCheckoutRefunds: [
        {
          name: 'refunds/create',
          label: 'Integrations_Shopify_Webhooks_Label_Create',
          value: false
        }
      ],
      rules: {
        type: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        }
      }
    }
  },

  mounted() {
    this.updateTopics()
  },

  watch: {
    selectedEvents: {
      deep: true,
      handler() {
        this.model.params.topics = this.selectedEvents
      }
    }
  },

  computed: {
    events() {
      return [
        {
          label: 'Integrations_Shopify_Webhook_Checkout',
          description: 'Integrations_Shopify_Webhook_Checkout_Description',
          values: this.webhookCheckoutEvents
        },
        {
          label: 'Integrations_Shopify_Webhook_Customers',
          description: 'Integrations_Shopify_Webhook_Customers_Description',
          values: this.webhookCustomersEvents
        },
        {
          label: 'Integrations_Shopify_Webhook_DraftOrders',
          description: 'Integrations_Shopify_Webhook_DraftOrders_Description',
          values: this.webhookDraftOrdersEvents
        },
        {
          label: 'Integrations_Shopify_Webhook_Orders',
          description: 'Integrations_Shopify_Webhook_Orders_Description',
          values: this.webhookOrdersEvents
        },
        {
          label: 'Integrations_Shopify_Webhook_OrderTransactions',
          description:
            'Integrations_Shopify_Webhook_OrderTransactions_Description',
          values: this.webhookCheckoutOrderTransactions
        },
        {
          label: 'Integrations_Shopify_Webhook_Refunds',
          description: 'Integrations_Shopify_Webhook_Refunds_Description',
          values: this.webhookCheckoutRefunds
        }
      ]
    },

    webhooks() {
      return [
        ...this.webhookCheckoutEvents,
        ...this.webhookCustomersEvents,
        ...this.webhookDraftOrdersEvents,
        ...this.webhookOrdersEvents,
        ...this.webhookCheckoutOrderTransactions,
        ...this.webhookCheckoutRefunds
      ]
    },

    selectedEvents() {
      return this.webhooks.filter(ev => ev.value === true).map(ev => ev.name)
    }
  },

  methods: {
    updateTopics() {
      if (this.model.params.topics) {
        this.model.params.topics.forEach(topic => {
          for (let key in this.webhooks) {
            if (this.webhooks[key].name === topic) {
              this.webhooks[key].value = true
              break
            }
          }
        })
      } else {
        this.webhooks.forEach(webhook => {
          if (webhook.hasOwnProperty('defaultValue')) {
            webhook.value = webhook.defaultValue
          }
        })
      }
    },

    onCheckboxChange(event) {
      if (event.value === false && event.name === 'orders/create') {
        customConfirm(
          this.$t('Integrations_Shopify_Unsubscribe_Title'),
          this.$t('Integrations_Shopify_Unsubscribe_Event'),
          this.$t('ProfilePushSubscriptions_Action_Unsubscribe')
        ).catch(() => {
          event.value = true
        })
      }
    }
  }
}
</script>

<style scoped>
>>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #0087ce;
  border-color: #0087ce;
}

.webhook-desc {
  color: #7e8596;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/shopify/EventsStep.vue